import { render, staticRenderFns } from "./OrderCardDesktop.vue?vue&type=template&id=ec999da2&"
import script from "./OrderCardDesktop.vue?vue&type=script&lang=ts&"
export * from "./OrderCardDesktop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports